import { useId } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { DropdownButton } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { CountrySelectCombobox } from "app/pages/sales-intelligence/common-components/dropdown/CountrySelectCombobox";
import { FormFieldLabel } from "app/pages/sales-intelligence/common-components/form-fields";
import type { IFilterViewBaseModelProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import { StyledBaseDropdownButtonWrap } from "app/pages/sales-intelligence/sub-modules/advanced-search/components/common-styles";
import type { ICountryObject } from "app/services/CountryService";

import { COUNTRY_SELECT_WIDTH } from "../../../constants";
import type { IAppListedAddressFilterDto } from "../../../types/commonFiltersDto";
import { StyledDDContainer } from "../AppDownloadEngagementFilter/styles";

const ListedAddressFilter = ({
    filter,
    value,
    onFilterUpdate,
}: IFilterViewBaseModelProps<IAppListedAddressFilterDto, ICountryObject[]>) => {
    const { translate } = useTranslate();
    const dropdownId = useId();

    const renderDDButton = () => {
        return (
            <StyledBaseDropdownButtonWrap key="countries-dropdown-button">
                <DropdownButton>{translate("si.components.countries-dropdown.button.text")}</DropdownButton>
            </StyledBaseDropdownButtonWrap>
        );
    };

    const handleSelect = (country: ICountryObject) => {
        if (value?.countries.includes(country.id)) {
            const countries = value?.countries.filter((item: number) => item !== country.id);
            onFilterUpdate(countries.length > 0 ? { ...value, countries } : undefined);
        } else {
            onFilterUpdate({
                ...value,
                countries: value?.countries ? [...value?.countries, country.id] : [country.id],
            });
        }
    };

    return (
        <Flex
            flexDirection="column"
            maxWidth="263px"
            rowGap="16px"
        >
            <FormFieldLabel text={translate("si.common.countries")}>
                <StyledDDContainer
                    id={dropdownId}
                    customWidth={COUNTRY_SELECT_WIDTH}
                >
                    <CountrySelectCombobox
                        multi
                        onSelect={handleSelect}
                        selectedIds={value?.countries || []}
                        items={filter.options}
                        renderButton={renderDDButton}
                        searchPlaceHolder={translate("si.find_apps.filters.listed-address.country.placeholder")}
                    />
                </StyledDDContainer>
            </FormFieldLabel>
        </Flex>
    );
};

export default ListedAddressFilter;
